export enum OrderTypeEnum {
    Purchase,
    SaleToProvider,
    SaleToReverseDistributor,
    ReturnToWholesaler,
    Destruction
}